import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      INVITATION_SENT: "Invitasjon sendt!",
      CONTINUE_RECRUITING_FRIENDS_AND_PARTICIPAGE_IN_COMPETITION:
        "Fortsett å verve venner og vinn flotte premier i månedens konkurranse!",
      COLLECT_MORE_DISCOUNTS: "Samle flere rabatter",
      GOD_JOB: "Bra jobba!",
      INVITE_MORE_FRIENDS_WITHIN: "Verv flere innen",
      NOW_YOU_NEED_ONLY: "Nå trenger bare",

      NUM_OF_YOUR_FRIENDS: ({ numOfFriends }: { numOfFriends: number }) => {
        return `${numOfFriends} av dine venner`;
      },
      TO_RECEIVE_A_DELIVERY_BEFORE: ({
        cutOffDate,
      }: {
        cutOffDate: string;
      }) => {
        return `å motta en leveranse innen ${cutOffDate}`;
      },
      TIPS: "Tips",
      THE_MORE_PEOPLE_YOU_INVITE_THE_MORE_DISCOUNTS_YOU_GET:
        "jo flere du verver, desto større sjanse har du til å vinne konkurransen!",
      THIS_INVITATON_DOES_NOT_COUNT_TOWARDS_THE_COMPETITION:
        "Denne invitasjonen telles ikke med i konkurransen",
    },
    se: {
      INVITATION_SENT: "Inbjudan skickad!",
      CONTINUE_RECRUITING_FRIENDS_AND_PARTICIPAGE_IN_COMPETITION:
        "Fortsätt värva vänner och ta del av fina priser i månadens tävling!",
      COLLECT_MORE_DISCOUNTS: "Samla flera rabatter",
      GOD_JOB: "Snyggt jobbat!",
      INVITE_MORE_FRIENDS_WITHIN: "Bjud in flera inom",
      NOW_YOU_NEED_ONLY: "Nu behöver bara",

      NUM_OF_YOUR_FRIENDS: ({ numOfFriends }: { numOfFriends: number }) => {
        return `${numOfFriends} av dina vänner`;
      },
      TO_RECEIVE_A_DELIVERY_BEFORE: ({
        cutOffDate,
      }: {
        cutOffDate: string;
      }) => {
        return `ta emot en leverans innan ${cutOffDate}`;
      },
      THE_MORE_PEOPLE_YOU_INVITE_THE_MORE_DISCOUNTS_YOU_GET:
        "ju fler du bjuder in, desto större chans har du att vinna tävligen!",
      TIPS: "Tips",
      THIS_INVITATON_DOES_NOT_COUNT_TOWARDS_THE_COMPETITION:
        "Denna inbjudan räknas inte till tävlingen",
    },
    dk: {
      INVITATION_SENT: "Invitation sendt!",
      CONTINUE_RECRUITING_FRIENDS_AND_PARTICIPAGE_IN_COMPETITION:
        "Fortsæt med at anbefale os til dine venner og vind flotte præmier i månedens konkurrence.",
      COLLECT_MORE_DISCOUNTS: "Saml flere rabatter",
      GOD_JOB: "Godt gået!",
      INVITE_MORE_FRIENDS_WITHIN: "Anbefal til flere inden for",
      NOW_YOU_NEED_ONLY: "Nu mangler kun",
      NUM_OF_YOUR_FRIENDS: ({ numOfFriends }: { numOfFriends: number }) => {
        return `${numOfFriends} af dine venner at`;
      },
      TO_RECEIVE_A_DELIVERY_BEFORE: ({
        cutOffDate,
      }: {
        cutOffDate: string;
      }) => {
        return `modtage en levering inden ${cutOffDate}`;
      },
      THE_MORE_PEOPLE_YOU_INVITE_THE_MORE_DISCOUNTS_YOU_GET:
        "Jo flere du anbefaler os til, jo større er din chance for at vinde konkurrencen!",
      TIPS: "Tip!",
      THIS_INVITATON_DOES_NOT_COUNT_TOWARDS_THE_COMPETITION:
        "Denne invitation tæller ikke med i konkurrencen",
    },
  } as const
)[language];
